function $create($callback){

      // name stuff already!
      $(".s4com-helpcenter > div:nth-of-type(1)").addClass( "s4com-search" );
      $(".s4com-helpcenter > div:nth-of-type(2)").addClass( "s4com-main" );
      $(".s4com-sub-heading").parent("a").addClass( "s4com-h3" );
      
      // wrap first 3 questions (only 3 needed for new top section) with their heading so we can clone them
      $('.s4com-section-body').each(function(){
        $(this)
		.prev('a').add(this).wrapAll('<div class="help-section">')
		.find(".s4com-articles").slice(0,3).wrapAll('<div class="help-qas">')
      });
      
      // insert div after search box
      $(".s4com-search").after("<div class='help-toc'>");
      
      // copy sections to new div but strip out the answers, then remove href
      var $clone = $(".help-section").clone();
      $( $clone ).prependTo(".help-toc").find(".s4com-section-body > .s4com-articles, .s4com-article-body, .s4com-icon-wrap").remove();
      $( $clone ).find(".s4com-articles > a").removeAttr("href").prepend("<span>›</span> ");
      
      // strip junk tags
      $( $clone ).find(".s4com-h3, .s4com-section-body").replaceWith(function(){
        return $(this).contents();
      }); 
      
      // convert h3 tags to DIV
      $( $clone ).find("h3.s4com-sub-heading").replaceWith(function(){
        return $("<div class='help-section-heading' />")
        .append($(this).contents())
        .wrapInner('<span class="help-section-title" />')
        .prepend("<span class='help-section-icon' />")
        .wrapInner('<span />')
        .append('<span class="vmid" />');
        //.wrapInner('<a href="#" />');
      });
      
      // convert cloned questions to a list
      $( $clone ).find(".help-qas .s4com-articles").replaceWith(function(){
        return $("<li />").append($(this).contents());
      });
      
      // convert to UL and create "see all" link using heading text as anchor
      $(".help-toc .help-qas").each(function() {
        var $htext = $(this).prev(".help-section-heading").text();
        $('<li class="help-quest-last"/>')
        .append($('<a />', {text: "See all ›", href:'#'+$htext
	        .replace(/\s/g, '-')
	        .replace(/,/g, '')
	        .replace(/\?/g, '')
	        .replace(/&/g, '')
	        .replace(/\//g, '')
	        .replace(/'/g, '')
            .replace(/"/g, '')
	        .toLowerCase() + "-section"}))
            .appendTo($(this));
        $(this).replaceWith(function(){
          return $("<ul />").append($(this).contents());
        });
      });
        
      // "see all" onclick scroll
      $(".help-quest-last a").on("click", function( e ) {
        e.preventDefault();
        var $height = parseInt($('.content').css('padding-top'), 10);
        $("body, html").animate({ 
          scrollTop: $( $(this).attr('href') ).offset().top - $height + 20
        }, 666);
      });
        
      // add links back into top questions (removed/reinserted because s4's show/hide is based on anchor)
      $(".help-toc h4").each(function(){
        var $qtext = $(this).text();
        $(this).parent().attr("href", "#" + $qtext
                              .replace(/\s/g, '-')
                              .replace(/,/g, '')
                              .replace(/\?/g, '')
                              .replace(/&/g, '')
                              .replace(/\//g, '')
                              .replace(/'/g, '')
                              .replace(/"/g, '')
                              .toLowerCase() + "-answer");
        // when clicked, jump to id and show answer (note: s4 removed default clicks with preventdefault)
        $(this).parent().on("click", function( e ) {
          e.preventDefault();
          $( $(this).attr('href') ).addClass("s4com-active").next().show();
//          var $height = $(".header.mm-fixed-top").outerHeight();
          var $height = parseInt($('.content').css('padding-top'), 10);
          $("body, html").animate({ 
            scrollTop: $( $(this).attr('href') ).offset().top - $height + 20
          }, 666);
        });
        // convert to spans
        $(this).replaceWith(function(){
          return $("<span />").append($(this).contents());
        });
      });
      
      // attempt to offset search result jump
//      var $height = parseInt($('.content').css('padding-top'), 10);
//      jqS4com('html, body').animate({
//        scrollTop: target.offset().top - $height + 20
//      });
        
//      $(".tt-suggestion").on("click", function( e ) {
//        e.preventDefault();
//        var $height = parseInt($('.content').css('padding-top'), 10);
//        $("body, html").animate({ 
//          scrollTop: $( $(this).siblings("a").attr('href') ).offset().top - $height + 200
//        }, 666);
//      });
        
      // name anchors
      $(".s4com-main .s4com-sub-heading").each(function(){
        var $mhtext = $(this).text();
        $(this).attr("id", $mhtext
                     .replace(/\s/g, '-')
                     .replace(/,/g, '')
                     .replace(/\?/g, '')
                     .replace(/&/g, '')
                     .replace(/\//g, '')
                     .replace(/'/g, '')
                     .replace(/"/g, '')
                     .toLowerCase() + "-section");
      });
      $(".s4com-main .s4com-articles h4").each(function(){
        var $mqtext = $(this).text();
        $(this).parent().attr("id", $mqtext
                              .replace(/\s/g, '-')
                              .replace(/,/g, '')
                              .replace(/\?/g, '')
                              .replace(/&/g, '')
                              .replace(/\//g, '')
                              .replace(/'/g, '')
                              .replace(/"/g, '')
                              .toLowerCase() + "-answer");
      });

$callback();

}
      
function $callback(){
  
//  alert($(".help-toc .help-section-heading").height());
  
      // equalize height of sections
      var maxHeight = 0;
      $(".help-toc .help-section").each(function(){
//        alert($(this).height() + "ddd");
        if ($(this).height() > maxHeight) {
          maxHeight = $(this).height();
//          $(this).css("background", "green");
//          alert(maxHeight);
        }
        else {
//          $(this).css("background", "red");
        }
      });

      $(".help-toc .help-section").css("min-height", maxHeight);


if ($(window).width() < 600 || $(window).height() < 600) {
  
$('.help-toc .help-section').on('touchstart', function (e) {
    'use strict';
    var link = $(this); //preselect the link
    if (link.hasClass('hover')) {
        return true;
    } else {
        link.addClass('hover');
        $('.help-toc .help-section').not(this).removeClass('hover');
        e.preventDefault();
        return false;
    }
});
  
} else {
  
      $(".help-toc .help-section")
        .hover(
           function(){ $(this).addClass('hover') },
           function(){ $(this).removeClass('hover') }
        )
//        .touchstart(
//           function(){ $(this).addClass('hover') },
//           function(){ $(this).removeClass('hover') }
//        )
      ;
  
};
  
};
      
$create($callback);

